// extracted by mini-css-extract-plugin
export default {"wrapper":"Settings_wrapper__MUaFR","content":"Settings_content__o8gUQ"};